/**
 * Chilean RUT validator.
 * Validates format (e.g. 12345678-9) and check digit.
 */

function cleanRut(rut: string): string {
  return rut.replace(/\./g, '').replace(/-/g, '').trim().toUpperCase()
}

function calculateCheckDigit(body: string): string {
  let sum = 0
  let multiplier = 2

  for (let i = body.length - 1; i >= 0; i--) {
    sum += Number(body[i]) * multiplier
    multiplier = multiplier === 7 ? 2 : multiplier + 1
  }

  const remainder = 11 - (sum % 11)
  if (remainder === 11) return '0'
  if (remainder === 10) return 'K'
  return String(remainder)
}

/**
 * Returns true if the given Chilean RUT is valid.
 * Accepts formats: 12345678-9, 12.345.678-9, 123456789
 */
export function isValidRut(rut: string): boolean {
  if (!rut || rut.length < 2) return false

  const cleaned = cleanRut(rut)
  if (cleaned.length < 2) return false

  const body = cleaned.slice(0, -1)
  const checkDigit = cleaned.slice(-1)

  if (!/^\d+$/.test(body)) return false

  return calculateCheckDigit(body) === checkDigit
}

/**
 * Formats a RUT to standard display format: 12.345.678-9
 */
export function formatRut(rut: string): string {
  const cleaned = cleanRut(rut)
  if (cleaned.length < 2) return rut

  const body = cleaned.slice(0, -1)
  const checkDigit = cleaned.slice(-1)

  const formatted = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return `${formatted}-${checkDigit}`
}
